import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { Avatar, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ScrollToTopButton from 'shared/components/ScrollToTopButton';

const ClaimCatererProfileCTA = ({
  catererName,
  openClaimCatererProfileForm,
}) => {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { t } = useTranslation('caterers');

  return (
    <StyledContainer mobile={mobile}>
      <StyledLeftContainer mobile={mobile}>
        <Avatar />
        <StyledCTATextContainer>
          <StyledCTATextHeader mobile={mobile}>
            {`${t('caterer.customizeProfileCTAHeader')}${catererName}?`}
          </StyledCTATextHeader>
          <Typography>{t('caterer.customizeProfileCTALabel')}</Typography>
        </StyledCTATextContainer>
      </StyledLeftContainer>
      <StyledButton
        onClick={openClaimCatererProfileForm}
        outlined
        mobile={mobile}
      >
        {t('caterer.customizeProfileButton')}
      </StyledButton>
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: ${(props) => (props.mobile ? 'column' : 'row')};
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing(1)}px;
  background: #f8f8f8;
`;

const StyledLeftContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(props.mobile ? 2 : 0)}px;
`;

const StyledCTATextContainer = styled(Box)`
  flex: 1;
  margin-left: ${(props) => props.theme.spacing(2)}px;
`;

const StyledCTATextHeader = styled(Typography)`
  font-size: ${(props) =>
    props.theme.typography[props.mobile ? 'body1' : 'subtitle1'].fontSize};
  font-weight: ${(props) =>
    props.theme.typography[props.mobile ? 'h3' : 'subtitle1'].fontWeight};
`;

const StyledButton = styled(ScrollToTopButton)`
  border-radius: ${(props) => props.theme.spacing(1)}px;
  margin-top: ${(props) => props.theme.spacing(props.mobile ? 0 : 3)}px;
  margin-bottom: ${(props) => props.theme.spacing(props.mobile ? 1 : 3)}px;
`;

export default ClaimCatererProfileCTA;
